import type { Locale } from "@borealis/layout-express";
import { i18n } from "@lingui/core";
import { dynamicLoadTranslations as dynamicLoadDealerTranslations } from "@mobility-item-page/dealer";

export async function dynamicActivate(locale?: Locale) {
  const localeToLoadAndActivate: Locale = locale ?? "en";

  const { messages } = await import(`../locales/${localeToLoadAndActivate}.mjs`);

  await dynamicLoadDealerTranslations(localeToLoadAndActivate);
  i18n.load(localeToLoadAndActivate, messages);
  i18n.activate(localeToLoadAndActivate);
}
